import Agent from "infrastructure/agent";
import { WorkScheduleOverrideMapper } from "features/planner/planner.mappers";

const getDashboardStats = () => Agent.get(`/dashboard/stats`);

const getWorkScheduleOverrideTimeSeries = (startDate, endDate) =>
  Agent.get(
    `/dashboard/schedule`,
    WorkScheduleOverrideMapper.to({
      startDate,
      endDate,
    }),
  );

const getEmployeesByEmployeeTypeAndCardContainerType = (
  employeeType,
  cardContainerType,
) =>
  Agent.get(`/dashboard/deploymentstatus`, {
    employeeType,
    cardContainerType,
  });

const getAvailablePersonnelOnshoreByCountry = countryTwoLetterCode =>
  Agent.get(`/dashboard/availablepersonnel/bycountry/${countryTwoLetterCode}`);

const getPersonnelOnshoreWithRequiredTimeoffByCountry = countryTwoLetterCode =>
  Agent.get(`/dashboard/timeoff/bycountry/${countryTwoLetterCode}`);

export default {
  getDashboardStats,
  getWorkScheduleOverrideTimeSeries,
  getAvailablePersonnelOnshoreByCountry,
  getEmployeesByEmployeeTypeAndCardContainerType,
  getPersonnelOnshoreWithRequiredTimeoffByCountry,
};
